/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_After_StartInputs */

const en_issue_after_start = /** @type {(inputs: Issue_After_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`must be after the start`)
};

/**
* | output |
* | --- |
* | "must be after the start" |
*
* @param {Issue_After_StartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_after_start = /** @type {((inputs?: Issue_After_StartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_After_StartInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_after_start(inputs)
});